import { useStore } from "@store/index"

export const useSubtopic = (subtopicId: string) => {
  const { expertInsightsStore } = useStore()
  return expertInsightsStore.subtopicStore.getEntity(subtopicId)
}

export default useSubtopic
